<template>
	<section id="whitelist">
			<div class="wrapper p-0">
				<div class="video-wrapper">
					<video autoplay muted loop>
						<source src="/images/lux_room_compressed.mp4" type="video/mp4">
					</video>
				</div>


				<div class="overlay">
					<div class="row my-5">
						<div class="col-md-12 col-sm-12">
							<div class="card h-100 mb-5">
								<div class="card-body text-center">
									<h1 class="mb-3 text-uppercase mt-3">Whitelist</h1>

									<h5>Chance to win free land tile and NFT's</h5>
									<p class="mb-5">Priority mint access 1 day before public release & be kept in the loop with
										all upcoming & future drops.</p>

<!--									<a :href="campaignLink" target="_blank" class="btn btn-secondary btn-lg px-5">Apply For Whitelist</a>-->
									<button disabled class="btn btn-secondary btn-lg px-5">Whitelist Full</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

	</section>
</template>

<script>
export default {
	name: "WhitelistSection",
	data() {
		return {
			campaignLink: "https://gleam.io/vIkiV/alphabatem-initial-nft-land-sale-whitelist"
		}
	}
}
</script>

<style scoped>
.alert-info {
	background-color: rgba(0, 0, 0, 0.05);
	border-color: #f7f7f7;
	color: white;
	cursor: pointer;
	transition: 0.2s ease-in-out;
}

.alert-info:hover {
	background-color: rgba(0, 0, 0, 0.7);
	border-color: #f7f7f7;
	color: white;
}

.video-wrapper {
	height: 600px;
}
</style>